import { Header, Section, Footer } from "./components";
function App() {
  return (
    <div className="max-w-screen min-h-screen bg-gray-100 dark:bg-dark-bg">
      <Header/>
      <Section/>
      <Footer/>
    </div>
  );
}

export default App;
